import cn from 'classnames';
import Flex from '@creditflowresearch/uilib/Flex';
import Breadcrumb, { IBreadcrumb } from '@creditflowresearch/uilib/Breadcrumb';

import styles from './breadcrumbs.module.scss';

interface IProps {
  breadcrumbs?: IBreadcrumb[],
  wrapperClassName?: string,
}

const Breadcrumbs = ({
  breadcrumbs = [],
  wrapperClassName,
}: IProps) => {
  if (!breadcrumbs?.length) {
    return null;
  }

  return (
    <div className={ cn(styles.breadcrumbsWrapper, wrapperClassName) }>
      <Flex className={ styles.breadcrumbsContentWrapper }>
        { breadcrumbs.map(
          (breadcrumb: IBreadcrumb) => <Breadcrumb key={ breadcrumb.url || breadcrumb.title } { ...breadcrumb } />,
        ) }
      </Flex>
    </div>
  );
};

export default Breadcrumbs;
